import {createSlice, Draft, PayloadAction} from "@reduxjs/toolkit"
import {createAsyncThunk} from "@reduxjs/toolkit";
import httpClient from "../services/httpClient";
import {IUserStoreData} from "../contracts/data/user";
import {authApi} from "../constans/apiUrls";

const initialState:IUserStoreData = {
    first_name: "",
    last_name: "",
    mobile: "",
    avatar: "",
    permissions: []
}

export const fetchUserInfo = createAsyncThunk('user/fetchUserInfo', async () => {
    const res = await httpClient().get(authApi.profile)
    console.log(res)
    return res?.data
})

export const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers:{},
    extraReducers: {
        [fetchUserInfo.fulfilled.toString()]: (state, action:PayloadAction<IUserStoreData>) => action.payload,
    }
})

export const {} = userSlice.actions

export default userSlice.reducer